import React, { Component } from "react";
import { connect } from "react-redux";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import keywordActions from "../../../../_actions/keywordActions";

class EditKeywordModal extends Component {
  state = {
    formData: {
      projectId: 0,
      keywordId: 0,
      keywordTag: "",
      description: "",
      createdByUserId: 0,
      isDefault: false,
    },
    formErrors: {
      keywordTag: null,
      description: null,
    },
  };

  componentDidMount() {
    const { projectId, selectedKeyword, isNew } = this.props;

    if (selectedKeyword && !isNew) {
      this.setState({
        formData: {
          ...this.state.formData,
          keywordId: selectedKeyword.keywordId,
          projectId,
          keywordTag: selectedKeyword.keywordTag,
          description: selectedKeyword.description || "",
        },
      });
    }
  }

  handleChange_editKeywordForm = (e) => {
    const formData = { ...this.state.formData };
    formData[e.target.name] = e.target.value;
    this.setState({ formData });
  };

  handleBlur_editKeywordForm = (e) => this.validateForm(e.target.name);

  validateForm = (fieldName) => {
    const { formData } = this.state;
    const formErrors = { ...this.state.formErrors };
    switch (fieldName) {
      case "keywordTag":
        if (formData.keywordTag == null) formErrors.keywordTag = "Tag is required";
        else formErrors.keywordTag = null;
        break;
      case "description":
        if (formData.description === "")
          formErrors.description = "Description is required";
        else formErrors.description = null;
        break;
      default:
        break;
    }
    this.setState({ formErrors });
  };

  formIsIncomplete = () => {
    const { keywordTag, description } = this.state.formErrors;
    const { formData } = this.state;
    if (
      keywordTag ||
      description ||
      formData.keywordTag === "" ||
      formData.description === ""
    )
      return true;
    else return false;
  };

  handleSubmit_editKeywordForm = async (e) => {
    e.preventDefault();
    const { projectId, dispatch, toggleEditKeywordModal, user, isNew } = this.props;
    const formData = { ...this.state.formData };
    formData.keywordTag = formData.keywordTag.toLowerCase();
    formData.projectId = projectId;
    formData.createdByUserId = user.userId;
    if (!this.formIsIncomplete()) {
      if (isNew) await dispatch(keywordActions.add(formData));
      else await dispatch(keywordActions.update(formData));
      this.resetFormData();
      toggleEditKeywordModal();
    }
  };

  resetFormData = () => {
    const formData = {
      projectId: 0,
      keywordId: 0,
      keywordTag: "",
      description: "",
      createdByUserId: 0,
      isDefault: false,
    };
    this.setState({ formData });
  };

  toggleAlert_errorOnSubmit = () => {
    this.setState({
      showAlert_errorOnSubmit: !this.state.showAlert_errorOnSubmit,
    });
  };

  handleAlert_errorOnSubmit = () => (e) => {
    e && e.preventDefault();
    this.toggleAlert_errorOnSubmit();
  };

  render() {
    const { formData, formErrors } = this.state;
    const { showEditKeywordModal, toggleEditKeywordModal, isNew } = this.props;
    const closeBtn = (
      <button className="close" onClick={toggleEditKeywordModal}>
        <FontAwesomeIcon icon="times" className="fa-fw text-white" />
      </button>
    );
    return (
      <React.Fragment>
        <Modal
          isOpen={showEditKeywordModal}
          toggle={toggleEditKeywordModal}
          className={this.props.className}
          size={"ml"}
          fade={false}
        >
          <ModalHeader
            toggle={toggleEditKeywordModal}
            className="bg-info text-white"
            close={closeBtn}
          >
            <FontAwesomeIcon icon={isNew ? "plus" : "edit"} className="fa-fw mr-2" />
            {isNew ? "Add New Keyword" : "Edit Keyword"}
          </ModalHeader>
          <ModalBody>
            <form
              id="editKeywordForm"
              onSubmit={this.handleSubmit_editKeywordForm}
              autoComplete={"off"}
            >
              <div className="card m-2">
                <div className="card-body">
                  <div className="form-row form-group mb-2">
                    <label htmlFor="keywordTag" className="col-sm-3 col-form-label">
                      <b>Keyword Tag:</b>*
                    </label>
                    <div className="col-sm-8">
                      <input
                        type="text"
                        name="keywordTag"
                        id="keywordTag"
                        className="form-control"
                        maxLength="30"
                        value={formData.keywordTag}
                        onChange={this.handleChange_editKeywordForm}
                        onBlur={this.handleBlur_editKeywordForm}
                      />
                      {formErrors.keywordTag && (
                        <span className="error-small">
                          <small>{formErrors.keywordTag}</small>
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="form-row form-group mb-2">
                    <label htmlFor="description" className="col-sm-3 col-form-label">
                      <b>Description:</b>*
                    </label>
                    <div className="col-sm-8">
                      <textarea
                        name="description"
                        id="description"
                        className="form-control"
                        maxLength="500"
                        value={formData.description}
                        onChange={this.handleChange_editKeywordForm}
                        onBlur={this.handleBlur_editKeywordForm}
                      />
                      {formErrors.description && (
                        <span className="error-small">
                          <small>{formErrors.description}</small>
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </ModalBody>
          <ModalFooter>
            <div className="form-row form-group">
              <input
                className="btn btn-primary"
                name="submitEditKeywordButton"
                type="submit"
                form="editKeywordForm"
                onClick={this.handleSubmit_editKeywordForm}
                value={isNew ? "Add" : "Save"}
                disabled={this.formIsIncomplete()}
              />{" "}
              <button
                className="btn btn-secondary ml-2"
                color="secondary"
                onClick={toggleEditKeywordModal}
              >
                Cancel
              </button>
            </div>
          </ModalFooter>
        </Modal>
      </React.Fragment>
    );
  }
}

export default connect()(EditKeywordModal);
